import React, { Component } from "react";
import Chapter from "./Chapter";
import {
  CoursePreviewResource,
  Topic,
} from "../../../../stores/CoursePreviewStore/Types";

interface Props {
  topics: Topic[];
  courseSlug: string;
  course: CoursePreviewResource;
}

interface State {
  showAllTopics: boolean;
}

class CourseChapters extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      showAllTopics: false,
    };
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.topics !== this.props.topics && this.state.showAllTopics) {
      this.setState({
        showAllTopics: false,
      });
    }
  }

  showAllTopics = (e) => {
    e.preventDefault();

    this.setState({
      showAllTopics: true,
    });
  };

  render() {
    const { showAllTopics } = this.state;
    const { courseSlug, course } = this.props;
    const topics = this.props.topics || [];
    const hasHiddenChapters = topics.length > 4;
    const visibleLessonCount = course?.total_questions_count || 0;
    const chapterSummary = `${course?.topics_number_in_words} ${
      topics.length === 1 ? "chapter" : "chapters"
    }${`, ${visibleLessonCount} ${
      visibleLessonCount === 1 ? "lesson" : "lessons"
    }`}`;

    return (
      <section
        className={`chapters${showAllTopics ? " expanded" : ""}`}
        id="chapters"
        aria-labelledby="chap-title"
      >
        <div className="container">
          <div className="head">
            {/* Kept for screen readers and search engines, not shown. */}
            <span className="sr-only">The course chapters</span>
            <h2 className="section-title" id="chap-title">
              What we'll cover,{" "}
              <span className="nobr">
                <em className="hl">in order</em>.
              </span>
            </h2>
            <p className="section-sub">
              {chapterSummary}. Click any chapter to see the lesson list.
            </p>
          </div>

          <div className="chap-list" id="chapList">
            {topics.map((topic, idx) => (
              <Chapter
                key={topic.id || idx}
                courseSlug={courseSlug}
                hidden={!showAllTopics && idx >= 4}
                position={idx + 1}
                topic={topic}
              />
            ))}
          </div>

          {!showAllTopics && hasHiddenChapters && (
            <button
              type="button"
              className="show-more-chapters"
              onClick={this.showAllTopics}
              aria-expanded="false"
              aria-controls="chapList"
            >
              Show all {topics.length} chapters{" "}
              <span className="ar" aria-hidden="true">
                ↓
              </span>
            </button>
          )}

          <p className="all-row">
            <strong>Eight hours of CPD.</strong> Plenty to chew on. None of it
            filler.
          </p>
        </div>
      </section>
    );
  }
}

export default CourseChapters;
